export class StandBarcodeSourceFieldsDB {

    public static standBarcodeSourceFields = [
        {
            "entity": "Persons",
            "fields": [
                "PersonNumber",
                "AddressPreference",
                "IdentificationType",
                "IdentificationTypeValue",
                "FirstName",
                "MiddleName",
                "LastName",
                "BirthDate",
                "Gender",
                "Prefix",
                "Suffix",
                "PhoneNumber",
                "MobileNumber",
                "Status",
                "ProfilePreference",
                "CreatedDateUtc",
                "Origin",
                "FreeField1",
                "FreeField2",
                "FreeField3",
                "FreeField4",
                "FreeField5",
                "FreeField6",
                "FreeField7",
                "FreeField8",
                "FreeField9",
                "FreeField10",
                "FreeField11",
                "FreeField12",
                "FreeField13",
                "FreeField14",
                "FreeField15",
                "FreeField16"
            ]
        },
        {
            "entity": "Cardholders",
            "fields": [
                "Email",
                "BusinessUnit",
                "ExternalCompany",
                "Department",
                "CostAccount",
                "Location",
                "JobTitle",
                "StartDate",
                "EndDate",
                "Status",
                "NameOnCard",
                "Note",
                "Created",
                "ProfileNumber",
                "FreeField1",
                "FreeField2"
            ]
        },
        {
            "entity": "Cards",
            "fields": [
                "CreatedDateUtc",
                "ModifiedDateUtc",
                "CardNumber",
                "ChipserialNumber",
                "Status",
                "StartDateUtc",
                "EndDateUtc",
                "ActivatedOnUtc"
            ]
        }
    ]
}